import { Flex, TextHeadingTwo, Text } from '@cko/primitives';
import React from 'react';
import styled from 'styled-components';
const StyledSection = styled.div `
  &:not(:last-child) {
    margin-bottom: var(--layout-sofa);
  }
`;
const Header = styled(Flex) `
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const FormSection = ({ children, description, rightElement, errorMessage, title, ...divProps }) => {
    return (React.createElement(StyledSection, { ...divProps },
        React.createElement(Header, { justifyContent: "space-between", marginBottom: description ? 'var(--layout-soybean)' : 'var(--layout-spoon)', paddingBottom: "var(--layout-soybean)", alignItems: "center" },
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", width: "100%" },
                React.createElement(Flex, null,
                    React.createElement(TextHeadingTwo, { color: "var(--base-text-secondary)" }, title),
                    errorMessage && (React.createElement(Text, { color: "var(--control-text-bad)", marginLeft: "var(--layout-soybean)" }, errorMessage))),
                rightElement),
            description && React.createElement(Text, { marginBottom: "var(--layout-spoon)" }, description)),
        children));
};
